


























































import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class FilterCurrent extends Vue {
  @Prop() filter: string[]
  @Prop() setFilter: (string)
}

